import { Utility, utility_controller } from '../utility/utility_controller'
import { Breakpoints } from '../breakpoints/breakpoints_controller'

var parallax_controller = {
	i: function () {
		i()
	},
}

export default parallax_controller

// cols: array of array: [jQuery(this), yvel, ytranslate, yoffset, xoffset];

var stateMap = {
	cols: [],
	scrollY: 0,
	parallaxActive: false,
}

var getTransforms = function (trans) {
	return {
		'-webkit-transform': trans,
		'-moz-transform': trans,
		'-ms-transform': trans,
		transform: trans,
	}
}

var getDirectLayContentChild = function (root) {
	if (!root || !root.children) {
		return null
	}
	for (var i = 0; i < root.children.length; i++) {
		var child = root.children[i]
		if (child instanceof HTMLElement && child.classList.contains('lay-content')) {
			return child
		}
	}
	return null
}

var getScrollContainerForCol = function (col) {
	if (!col || typeof col.closest !== 'function') {
		return window
	}

	var pageOverlay = col.closest('.lay-overlay')
	if (pageOverlay) {
		var pageOverlayContent = getDirectLayContentChild(pageOverlay)
		if (pageOverlayContent && pageOverlayContent.contains(col)) {
			return pageOverlayContent
		}
		return pageOverlay
	}

	var projectOverlay = col.closest('#lay-project-overlay')
	if (projectOverlay) {
		return projectOverlay
	}

	return window
}

var getContainerScrollTop = function (container) {
	return container === window ? window.scrollY || document.documentElement.scrollTop || 0 : container.scrollTop || 0
}

var getContainerHeight = function (container) {
	return container === window ? window.innerHeight : container.clientHeight || window.innerHeight
}

var getRectTopInContainer = function (el, container) {
	var rect = el.getBoundingClientRect()
	if (container === window) {
		return rect.top
	}
	var containerRect = container.getBoundingClientRect()
	return rect.top - containerRect.top
}

var getStoredParallaxYTranslate = function (el) {
	var ytranslate = parseFloat(el._layParallaxYTranslate)
	return isNaN(ytranslate) ? 0 : ytranslate
}

var getFiniteParallaxNumber = function (value, fallback) {
	var number = parseFloat(value)
	return isFinite(number) ? number : fallback
}

var getTranslateYFromTransformString = function (transform) {
	if (!transform || transform === 'none') {
		return 0
	}
	if (transform.indexOf('matrix3d(') === 0) {
		var matrix3dValues = transform.substring(9, transform.length - 1).split(',')
		var matrix3dY = parseFloat(matrix3dValues[13])
		return isFinite(matrix3dY) ? matrix3dY : 0
	}
	if (transform.indexOf('matrix(') === 0) {
		var matrixValues = transform.substring(7, transform.length - 1).split(',')
		var matrixY = parseFloat(matrixValues[5])
		return isFinite(matrixY) ? matrixY : 0
	}
	if (transform.indexOf('translate3d(') === 0 || transform.indexOf('translate(') === 0) {
		var start = transform.indexOf('(') + 1
		var end = transform.indexOf(')')
		var values = transform.substring(start, end).split(',')
		var yValue = values.length > 1 ? parseFloat(values[1]) : 0
		return isFinite(yValue) ? yValue : 0
	}
	return 0
}

var getCurrentTranslateY = function (el) {
	if (!el) {
		return 0
	}
	var transform = el.style ? el.style.transform : ''
	if (!transform || transform === 'none') {
		try {
			transform = window.getComputedStyle(el).transform
		} catch (e) {}
	}
	return getTranslateYFromTransformString(transform)
}

var isNavTransitionParallaxSuspended = function (el) {
	if (!el || !el.classList || !el.classList.contains('lay-nav-transition-in-target')) {
		return false
	}
	return getFiniteParallaxNumber(el._layNavTransitionBaseTranslateY, null) !== null
}

// stateMap.cols[i] = [jQuery(this), yvel, ytranslate, yoffset, xoffset, isMiddleAlignedPositionAbsoluteElementIn100vhRow, offsetyMu, offsetxMu, scrollContainer]
var parallaxScroll = function () {

	for (var i = 0; i < stateMap.cols.length; i++) {
		var col = stateMap.cols[i][0][0]
		if (stateMap.cols[i][1] == 0) {
			continue
		}
		if (isNavTransitionParallaxSuspended(col)) {
			continue
		}
		var offsetX_mu = stateMap.cols[i][7]
		var offsetyMu = stateMap.cols[i][6]
		var scrollContainer = stateMap.cols[i][8] || window
		var scrollTop = getContainerScrollTop(scrollContainer)
		var viewportHeight = getContainerHeight(scrollContainer)
		if (viewportHeight <= 0) {
			continue
		}
		stateMap.scrollY = scrollTop

		var rect = col.getBoundingClientRect()
		if (rect.width <= 0 || rect.height <= 0) {
			continue
		}
		var rectTop = getRectTopInContainer(col, scrollContainer)
		var currentTransformY = getCurrentTranslateY(col)
		var offsetTop = rectTop - currentTransformY + scrollTop
		var previousYTranslate = getFiniteParallaxNumber(stateMap.cols[i][2], 0)
		stateMap.cols[i][2] = previousYTranslate
		// Use the element's untransformed top. `getBoundingClientRect()` includes
		// both parallax and nav-stagger transforms; subtract the current own
		// translateY instead of relying on the previous stored parallax value.
		var start = offsetTop - viewportHeight
		// if element is at top of page, in top viewport, I need to calculate this differently, otherwise the element jumps. 0% needs to be the start position of that element
		if (start < 0) {
			start = 0
		}
		var stop = offsetTop + rect.height
		// when image enters viewport, be at 0%. when we are scrolled to where it is not visible anymore, be at 100%
		var percentage = utility_controller.map(scrollTop, start, stop, 0, 100)

		if (!isFinite(percentage)) {
			continue
		}

		if (percentage < 0 || percentage > 100) {
			continue
		}
		// ytranslate = percentage * yvelocity * make_number_bigger
		stateMap.cols[i][2] = percentage * stateMap.cols[i][1] * 11.2
		col._layParallaxYTranslate = stateMap.cols[i][2]
		var translateY = stateMap.cols[i][2]
		switch (offsetyMu) {
			case 'px':
				// + yoffset
				translateY += parseFloat(stateMap.cols[i][3], 10)
				break
			case 'vw':
			case '%':
				// ytranslate += yoffset (yoffset is normally in vw, here i calculate px equivalent)
				translateY += (window.innerWidth / 100) * stateMap.cols[i][3]
				break
		}
		if (!isFinite(translateY)) {
			continue
		}

		// dont need this anymore!

		// if isMiddleAlignedPositionAbsoluteElementIn100vhRow, do translateY -= 50%
		// if(stateMap.cols[i][5] == true){
		// 	var rect = stateMap.cols[i][0][0].getBoundingClientRect();
		// 	translateY -= rect.height/2;
		// }
		var translateX = stateMap.cols[i][4]
		// var offsetX_mu = 'px';
		// if ( layData.offsets_mu == '%' ) {
		// 	offsetX_mu = 'vw';
		// }
		var transform = 'translate(' + translateX + offsetX_mu + ', ' + translateY + 'px)'
		col._layParallaxTransform = transform
		stateMap.cols[i][0].css(getTransforms(transform))
	}
}

var bindResize = function () {
	var lastSize = Utility.screenSize

	jQuery(window).on('window_width_changed orientationchange', function () {
		// here i dont care about the possibility that the footer custom phone layout could contain parallax elements. cause right now they wont work if the main layout does not have a custom phone layout too

		if (Utility.screenSize == 'phone' && lastSize == 'tablet' && Breakpoints.mainHasCustomPhoneGrid == false) {
			// disable
			if (stateMap.parallaxActive == true) {
				jQuery('.col').each(function () {
					this._layParallaxTransform = ''
					this._layParallaxYTranslate = 0
				}).css(getTransforms(''))
				window.eventsChannel.off('scroll', parallaxScroll)
				stateMap.parallaxActive = false
			}
		} else if (Utility.screenSize == 'tablet' && lastSize == 'phone') {
			// enable
			if (stateMap.parallaxActive == false && stateMap.cols.length > 0) {
				window.eventsChannel.on('scroll', parallaxScroll)
				stateMap.parallaxActive = true
			}
		}

		if (stateMap.parallaxActive) {
			parallaxScroll()
		}

		lastSize = Utility.screenSize
	})
}

var collectParallaxCols = function () {
	stateMap.cols = []
	jQuery('.col[data-yvel]').each(function () {
		var yvel = getFiniteParallaxNumber(jQuery(this).attr('data-yvel'), 1)
		if (yvel < 1) {
			yvel = 1
		}

		yvel -= 1
		yvel = -yvel

		var ytranslate = getStoredParallaxYTranslate(this)

		// y offset in vw, need to convert to pixels
		var yoffset = jQuery(this).attr('data-offsety')
		if (typeof yoffset == 'undefined') {
			yoffset = 0
		}
		yoffset = getFiniteParallaxNumber(yoffset, 0)
		var xoffset = jQuery(this).attr('data-offsetx')
		if (typeof xoffset == 'undefined') {
			xoffset = 0
		}
		xoffset = getFiniteParallaxNumber(xoffset, 0)

		var offsetyMu = jQuery(this).attr('data-offsetymu')
		if (offsetyMu == undefined) {
			offsetyMu = ''
		}
		var offsetxMu = jQuery(this).attr('data-offsetxmu')
		if (offsetxMu == undefined) {
			offsetxMu = ''
		}

		// need to handle MiddleAlignedPositionAbsoluteElementIn100vhRow differently cause it is pos: abs, top: 50%, transform: translateY(-50%)
		var isMiddleAlignedPositionAbsoluteElementIn100vhRow = false
		if (jQuery(this.parentNode.parentNode).hasClass('_100vh') && this.classList.contains('align-middle') && (jQuery(this).attr('data-type') == 'text' || jQuery(this).attr('data-type') == 'html' || this.classList.contains('absolute-position'))) {
			isMiddleAlignedPositionAbsoluteElementIn100vhRow = true
		}

		var arr = [jQuery(this), yvel, ytranslate, yoffset, xoffset, isMiddleAlignedPositionAbsoluteElementIn100vhRow, offsetyMu, offsetxMu, getScrollContainerForCol(this)]
		stateMap.cols.push(arr)
	})
}

var enableParallax = function () {
	window.eventsChannel.off('scroll', parallaxScroll)
	stateMap.scrollY = 0
	stateMap.parallaxActive = false

	if (stateMap.cols.length > 0) {
		if (Utility.isDesktopOrTabletSize || Breakpoints.mainHasCustomPhoneGrid) {
			window.eventsChannel.on('scroll', parallaxScroll)
			stateMap.parallaxActive = true
			parallaxScroll()
		}
	}
}

var refreshParallax = function () {
	collectParallaxCols()
	enableParallax()
}

var bindNewSingle = function () {
	window.laytheme.on('newpageshown', function () {
		refreshParallax()
	})

	window.laytheme.on('parallaxrefresh', function () {
		refreshParallax()
	})

	window.laytheme.on('overlayshown_animation_ended', function () {
		refreshParallax()
	})

	window.laytheme.on('projectoverlayclosed', function () {
		setTimeout(function () {
			refreshParallax()
		}, 0)
	})

	window.laytheme.on('smoothscroll', function () {
		if (stateMap.parallaxActive) {
			parallaxScroll()
		}
	})
}

var initParallax = function () {
	bindNewSingle()
	bindResize()
}

var i = function () {
	if (layData.simple_parallax == 'on') {
		initParallax()
	}
}
